import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 30" {...props}><path fill="currentColor" d="M25.7 23.1l-6.3-6.3a7.8 7.8 0 001.6-4.9A7.9 7.9 0 0013 4a8 8 0 00-8 8 8 8 0 0012.9 6.4l6.3 6.3a1 1 0 001.5 0c.4-.4.4-1.1 0-1.6zm-8.5-6.9a5.8 5.8 0 01-8.2 0A5.8 5.8 0 019 8a5.8 5.8 0 018.2 0 5.8 5.8 0 010 8.2z" /></svg>);